import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { kubernetesTranslationRef } from '@backstage/plugin-kubernetes/alpha';
import { kubernetesReactTranslationRef } from '@backstage/plugin-kubernetes-react/alpha';

export const kubernetesPtBr = createTranslationMessages({
    ref: kubernetesTranslationRef,
    full: false,
    messages: {
       "kubernetesContentPage.permissionAlert.title": "Permissões insuficientes",
       "kubernetesContentPage.permissionAlert.message": "Você não tem permissão suficiente para visualizar os objetos"
    }
});

export const kubernetesReactPtBr = createTranslationMessages({
    ref: kubernetesReactTranslationRef,
    full: false,
    messages: {
       "podDrawer.buttons.delete": "Deletar Pod"
    }
});